const preventClick = (document, selectorsArray = []) => {
  const elements = document.querySelectorAll(selectorsArray.join(', '));
  elements.forEach((el) => {
    // eslint-disable-next-line no-param-reassign
    el.style.pointerEvents = 'none';
  });
};

export default preventClick;
